import React from 'react';
import { Navigate, Route, Routes } from 'react-router';

import { AccountPage } from '@/pages/Account/Index';
import { AccountNameEditPage } from '@/pages/Account/NameEdit';
import { AccountPasswordEditPage } from '@/pages/Account/PasswordEdit';
import { AdminActivationPage } from '@/pages/Admin/Activation';
import { ActivationStartPage } from '@/pages/Activation/Start';
import { ActivationSuccessPage } from '@/pages/Activation/Success';
import { ActivationAlreadyActivatedContainer } from '@/pages/Activation/AlreadyActivated';
import { HomePage } from '@/pages/Home';
import { MembershipPage } from '@/pages/Membership/Index';
import { MembershipInvitePage } from '@/pages/Membership/Invite';
import { OpenidAuthorizationContainer } from '@/pages/Auth/Openid/Authorization';
import { OpenidCallbackContainer } from '@/pages/Auth/Openid/Callback';
import { OpenidSignoutContainer } from '@/pages/Auth/Openid/Signout';
import { PasswordResetPage } from '@/pages/PasswordReset/Index';
import { PasswordResetSuccessPage } from '@/pages/PasswordReset/Success';
import { PasswordResetStartPage } from '@/pages/PasswordReset/Start';
import { ServiceDetailPage } from '@/pages/Service/Detail';
import { SubscriptionDetailContainer } from '@/pages/Subscription/Detail';
import { SubscriptionEditContainer } from '@/pages/Subscription/Edit';
import { SubscriptionNewContainer } from '@/pages/Subscription/New';
import { TokenExpiredContainer } from '@/pages/Token/Expired';
import { TokenSentConatiner } from '@/pages/Token/Sent';
import { AuthGatewayPage } from '@/pages/Auth/Gateway';
import { UsersPage } from '@/pages/Users';
import { OrganizationsPage } from '@/pages/Organizations';

import { GuestRoute, PrivateRoute } from '@/components/utils/route';
import { pages } from './pages';

export default (
  <Routes>
    {/* GuestRoute */}
    <Route element={<GuestRoute />}>
      <Route path={pages.activation.start} element={<ActivationStartPage />} />
      <Route path={pages.admin.activate} element={<AdminActivationPage />} />
      <Route
        path={pages.activation.success}
        element={<ActivationSuccessPage />}
      />
      <Route
        path={pages.password.reset.start}
        element={<PasswordResetStartPage />}
      />
      <Route
        path={pages.password.reset.index}
        element={<PasswordResetPage />}
      />
      <Route
        path={pages.password.reset.success}
        element={<PasswordResetSuccessPage />}
      />
      <Route path={pages.auth.gateway} element={<AuthGatewayPage />} />
    </Route>

    {/* PrivateRoute memberAccessible: true */}
    <Route element={<PrivateRoute memberAccessible={true} />}>
      <Route path={pages.membership.index} element={<MembershipPage />} />
      <Route path={pages.account.name.edit} element={<AccountNameEditPage />} />
      <Route
        path={pages.account.password.edit}
        element={<AccountPasswordEditPage />}
      />
      <Route path={pages.account.index} element={<AccountPage />} />
      <Route
        path={pages.service.detail}
        element={<ServiceDetailPage />} // Notice: PageRootWrapper未対応
      />
      <Route path={pages.top} element={<HomePage />} />
      <Route path={pages.organizations} element={<OrganizationsPage />} />
    </Route>

    {/* PrivateRoute */}
    <Route element={<PrivateRoute />}>
      <Route
        path={pages.membership.invite}
        element={<MembershipInvitePage />}
      />
      <Route path={pages.users.index} element={<UsersPage />} />
      <Route
        path={pages.subscription.new}
        element={<SubscriptionNewContainer />}
      />
      <Route
        path={pages.subscription.edit}
        element={<SubscriptionEditContainer />}
      />
      <Route
        path={pages.subscription.detail}
        element={<SubscriptionDetailContainer />}
      />
    </Route>

    {/* OIDC */}
    <Route
      path={pages.signin.index}
      element={<OpenidAuthorizationContainer />}
    />
    <Route
      path={pages.auth.openid.callBack}
      element={<OpenidCallbackContainer />}
    />
    <Route path={pages.signout.index} element={<OpenidSignoutContainer />} />

    <Route
      path={pages.activation.alreadyCompleted}
      element={<ActivationAlreadyActivatedContainer />}
    />
    <Route path={pages.token.expired} element={<TokenExpiredContainer />} />
    <Route path={pages.token.sent} element={<TokenSentConatiner />} />
    <Route path="*" element={<Navigate to={pages.top} />} />
  </Routes>
);
